import NotificationImportantIcon from "@material-ui/icons/NotificationImportant";
import { SiteUpdate } from "./siteUpdateTrigger";

export default {
    create: SiteUpdate,
    list: SiteUpdate,
    icon: NotificationImportantIcon,
};
